import * as React from 'react';
import appService from '../../Service';
import { showErrorDialog,showLoading,Button,Util,Input,closeDialog} from 'baziigram';
import {useSelector, useDispatch} from 'react-redux'
import {persist} from "../../redux/actions"
import {useEffect,useRef} from "react";
import {useForm} from "react-hook-form";
import {UpdateUser} from "../../Util/user"
import  "./styles.css";
import {
    GAME_USER_LOGIN_ACTION_CLEAR,
    GAME_USER_LOGIN_ACTION_PERSIST
} from "../../redux/GameUserLogin/gameUserLogin.constant";
import Client from "../../Util/client";
import {dictionary} from "../../constants"
const GameUserLogin = () => {


    const {formData , language , direction} = useSelector(state =>  state.gameUserLogin)

    const dispatch = useDispatch();
    var remainingTime = useSelector(state => state.gameUserLogin.remainingTime)
    const form = useForm({defaultValues:{...formData},shouldFocusError: true});
    const {setValue,reset} = form
    const isMounted = React.useRef(false)

    var iv = useSelector(state => state.gameUserLogin.iv)

    const updateState = (state) => {
        dispatch(persist(state, GAME_USER_LOGIN_ACTION_PERSIST))
    }


    useEffect(()=>{
    if(isMounted.current==false)
        {isMounted.current= true
         dispatch(persist(null, GAME_USER_LOGIN_ACTION_CLEAR))
        }
         reset({...formData})
        let l = Util.getLanguage();
        updateState({language:l,direction:l=="fa"?"rtl":"ltr"})
    },[])

    useEffect(() => {
        if (remainingTime == 120)
            showTimerDialog()
    }, [remainingTime])


    const handleSubmit = () => {
          if((Util.mobile(formData.userName)==false && Util.email(formData.userName)==false) ) {
              window.dispatchEvent(new CustomEvent("baziigram-invalid-input"));
              return
          }
        showLoading(true)
        appService.GameUserLogin(formData.userName).then(res => {
            updateState({remainingTime:120})
        }).catch(err => {
            showErrorDialog(err.message || err)
        }).finally(res => {
            showLoading(false)
        })

    }

    const showTimerDialog = () => {
        iv = setInterval(decreaseTime, 1000);
        updateState({iv})

    }

    const handleVerifyOTP = () => {

        if (formData.otp.length != 5) {
            window.dispatchEvent(new CustomEvent('baziigram-invalid-input'))
            return
        }
        showLoading(true)
        closeLoginDialog();
        appService.GameUserVerify(formData.userName, formData.otp).then(res => {
        UpdateUser({"accessToken":res.accessToken , "refreshToken":res.refreshToken})
            disableTimer()
            dispatch(persist(null, GAME_USER_LOGIN_ACTION_CLEAR))
            reset()
            window.dispatchEvent( new CustomEvent("loginFinished"));

        }).catch(err => {
            disableTimer()
            showErrorDialog(err.message || err)
        }).finally(res => {
            showLoading(false)
        })
    }



    const decreaseTime = () => {
        if (remainingTime > 0) {
            remainingTime -= 1;
            updateState({remainingTime})
        } else
            disableTimer();
    }

    const disableTimer = () => {
        clearInterval(iv);
        formData.otp = ""
        updateState({formData, remainingTime: 0, iv: null})
    }


    const changeValue = (id, value) => {
        formData[id] = value
        updateState({formData})

    }

const endClose=(e)=>{
  if(e.animationName=="hide-dialog")
    {document.getElementById("loginModal").classList.remove("hide-dialog");
    document.getElementById("loginModal-container").style.display="none"
    }

  }


    return (<>
           {formData && <><div onClick={(e)=>{
           if(e.target.id=="loginModal-container")
           {closeLoginDialog()
           disableTimer()}
           }} className="dialog-container" id="loginModal-container" >
                <div className="dialog-content" id="loginModal" onAnimationEnd={endClose}>
                    <div onClick={(e) => {
                        e.stopPropagation();
                    }} >

                        <div className={"my-2 p-3"} style={{color: "#d83f87"}}>
                            <div className={`text-secondary my-2 mb-3 text-center ${direction}`}>
                             {dictionary.loginHint[language]}
                              </div>

                            {remainingTime > 0 && <div style={{fontSize:"2rem"}}
                                className={"text-center"}>{Util.padLeft(parseInt(remainingTime / 60), 2, "0")}:{Util.padLeft(remainingTime % 60, 2, "0")}</div>}
                           <div class="my-3">
                            <Input
                                form={form}
                                label={dictionary.userName[language]}
                                className="form-control "
                                maxLength={50}
                                id={"userName"}
                                required={true}
                                validator={(value)=>Util.mobile(value) || Util.email(value)}
                                value={formData.userName}
                                inputLabelClass="bg-light"
                                onChange={(id, value) =>
                                    changeValue(id, value)
                                }
                            />
                            </div>

                            {remainingTime > 0 &&  <Input
                                form={form}
                               label={dictionary.activationCode[language]}
                               inputLabelClass="bg-light"
                                className="form-control mb-3"
                                maxLength={5}
                                type={'tel'}
                                id={'otp'}
                                validator={(value) =>  remainingTime > 0 && value != null && value.length == 5}
                                value={formData.otp}
                                onChange={(id, value) => {
                                    formData[id] = value
                                    updateState({formData})
                                }}
                            />}
                            {remainingTime > 0 && <Button type={"button"} onClick={handleVerifyOTP} title={dictionary.ok[language]}/>}
                            {remainingTime == 0 && <Button type={"button"} onClick={handleSubmit} title={dictionary.sendOTPbtn[language]}/>}
                        </div>
                    </div>
                </div>
            </div>
               </>}
        </>
    );
};

export default GameUserLogin;


export const showLoginDialog=()=>{
document.getElementById("loginModal-container").style.display="block"
 setTimeout(function(){document.getElementById("loginModal").classList.add("show-dialog")},100)
}

export const closeLoginDialog=()=>{
closeDialog("loginModal")
}